import { useSelector } from "react-redux";
import Banner from "../../components/Banner/Banner";
import Main from "../../components/Main/_index";
import ServicesItem from "../../components/ServicesItem/ServicesItem";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Services = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <>
      <Main
        backimg="/img/servicesback.jpg"
        title={translations[selectedLanguages].servicesMain.title}
        context={translations[selectedLanguages].servicesMain.context}
      />
      <ServicesItem />
      <Banner />
    </>
  );
};

export default Services;
